import React from 'react';
import LegalLayout from './LegalLayout';

export default function Confidentialite() {
  return (
    <LegalLayout badge="RGPD" title="Politique de confidentialité"
      date="Dernière mise à jour : avril 2025 — Conforme au RGPD">

      <div className="legal-summary-grid">
        {[
          { icon: '🔒', title: 'Données sécurisées', desc: 'Chiffrement HTTPS, tokens JWT, accès strictement contrôlés' },
          { icon: '🚫', title: 'Pas de revente', desc: 'Vos données ne sont jamais vendues ni partagées à des tiers commerciaux' },
          { icon: '✋', title: 'Vos droits', desc: 'Accès, rectification, suppression sur simple demande' },
        ].map(c => (
          <div key={c.title} className="legal-summary-card">
            <div className="legal-summary-icon">{c.icon}</div>
            <div className="legal-summary-title">{c.title}</div>
            <div className="legal-summary-desc">{c.desc}</div>
          </div>
        ))}
      </div>

      <div className="legal-toc">
        <div className="legal-toc-title">Sommaire</div>
        <ol className="legal-toc-list">
          {['Responsable du traitement','Données collectées','Finalités et bases légales','Durée de conservation','Partage des données','Sécurité','Cookies et stockage local','Géolocalisation','Vos droits (RGPD)','Contact'].map((t,i) => (
            <li key={i}><a href={`#pc${i+1}`}>{i+1}. {t}</a></li>
          ))}
        </ol>
      </div>

      <div className="legal-content">
        <div className="legal-block" id="pc1">
          <h2>1. Responsable du traitement</h2>
          <p>Le responsable du traitement des données personnelles collectées via l'application Clockeo est :</p>
          <ul>
            <li><strong>Société :</strong> Clockeo</li>
            <li><strong>Siège social :</strong> À compléter</li>
            <li><strong>Email :</strong> <a href="mailto:contact@clockeo.fr">contact@clockeo.fr</a></li>
          </ul>
          <p>L'entreprise cliente (administrateur du compte) agit en qualité de <strong>responsable de traitement</strong> pour les données de ses propres employés. Clockeo intervient en tant que <strong>sous-traitant</strong> au sens du RGPD.</p>
        </div>

        <div className="legal-block" id="pc2">
          <h2>2. Données collectées</h2>
          <p>Clockeo collecte uniquement les données nécessaires au fonctionnement du service :</p>
          <div className="legal-table-wrap">
            <table className="legal-table">
              <thead>
                <tr><th>Catégorie</th><th>Données</th><th>Obligatoire</th></tr>
              </thead>
              <tbody>
                <tr><td><strong>Compte utilisateur</strong></td><td>Prénom, nom, adresse email, mot de passe (haché), numéro de téléphone (optionnel), rôle</td><td>Oui</td></tr>
                <tr><td><strong>Pointages</strong></td><td>Horodatage entrée/sortie, site concerné, méthode (QR ou GPS), coordonnées GPS au moment du pointage, distance au site</td><td>Oui</td></tr>
                <tr><td><strong>Navigation</strong></td><td>Dernière connexion, adresse IP (logs serveur), user-agent</td><td>Technique</td></tr>
                <tr><td><strong>Entreprise</strong></td><td>Nom de l'entreprise, sites (nom, adresse, coordonnées GPS), équipes</td><td>Oui</td></tr>
              </tbody>
            </table>
          </div>
          <div className="legal-success">
            <p>✅ Clockeo ne collecte aucune donnée biométrique, aucun document d'identité et aucune donnée sensible au sens de l'article 9 du RGPD.</p>
          </div>
        </div>

        <div className="legal-block" id="pc3">
          <h2>3. Finalités et bases légales</h2>
          <div className="legal-table-wrap">
            <table className="legal-table">
              <thead>
                <tr><th>Finalité</th><th>Base légale</th></tr>
              </thead>
              <tbody>
                <tr><td>Fourniture du service de pointage et de supervision</td><td>Exécution du contrat (art. 6.1.b RGPD)</td></tr>
                <tr><td>Gestion des comptes utilisateurs et authentification</td><td>Exécution du contrat (art. 6.1.b RGPD)</td></tr>
                <tr><td>Sécurité et lutte contre la fraude</td><td>Intérêt légitime (art. 6.1.f RGPD)</td></tr>
                <tr><td>Amélioration du service et statistiques d'usage</td><td>Intérêt légitime (art. 6.1.f RGPD)</td></tr>
                <tr><td>Support client</td><td>Exécution du contrat (art. 6.1.b RGPD)</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="legal-block" id="pc4">
          <h2>4. Durée de conservation</h2>
          <ul>
            <li><strong>Données de compte actif :</strong> pendant toute la durée du contrat</li>
            <li><strong>Données de pointage :</strong> selon le plan (30 jours en Gratuit, illimité en Pro/Business)</li>
            <li><strong>Logs de connexion :</strong> 12 mois glissants</li>
            <li><strong>Données après résiliation :</strong> 30 jours puis suppression définitive</li>
            <li><strong>Données de facturation :</strong> 10 ans (obligation légale comptable)</li>
          </ul>
        </div>

        <div className="legal-block" id="pc5">
          <h2>5. Partage des données</h2>
          <p>Clockeo <strong>ne vend jamais</strong> les données personnelles de ses utilisateurs. Les données peuvent être partagées uniquement avec :</p>
          <ul>
            <li><strong>Hébergeur (Hostinger) :</strong> dans le cadre de l'hébergement technique des données en Europe</li>
            <li><strong>L'entreprise cliente :</strong> les administrateurs ont accès aux données de pointage de leurs employés, dans le cadre du contrat de travail</li>
            <li><strong>Autorités compétentes :</strong> sur réquisition judiciaire uniquement</li>
          </ul>
          <p>Clockeo ne transfère pas de données personnelles en dehors de l'Espace Économique Européen (EEE).</p>
        </div>

        <div className="legal-block" id="pc6">
          <h2>6. Sécurité des données</h2>
          <p>Clockeo met en œuvre les mesures techniques et organisationnelles suivantes :</p>
          <ul>
            <li>Chiffrement des communications via HTTPS (TLS)</li>
            <li>Authentification par tokens JWT avec expiration courte (15 minutes)</li>
            <li>Mots de passe hachés (jamais stockés en clair)</li>
            <li>Accès aux données strictement limité par rôle (RBAC)</li>
            <li>Isolation des données entre entreprises clientes</li>
            <li>Sauvegardes régulières des données</li>
          </ul>
          <div className="legal-highlight">
            <p>En cas de violation de données susceptible d'engendrer un risque pour vos droits et libertés, Clockeo s'engage à notifier la CNIL dans les 72 heures et à vous en informer sans délai.</p>
          </div>
        </div>

        <div className="legal-block" id="pc7">
          <h2>7. Cookies et stockage local</h2>
          <p>Clockeo utilise le stockage local du navigateur (<code style={{ background: '#263348', padding: '2px 6px', borderRadius: 4, fontSize: 13 }}>localStorage</code>) uniquement pour :</p>
          <ul>
            <li>Conserver votre session de connexion (token d'authentification)</li>
            <li>Mémoriser vos préférences d'affichage</li>
          </ul>
          <p>Clockeo n'utilise <strong>aucun cookie de traçage</strong>, aucun outil d'analytics tiers et aucun pixel publicitaire.</p>
        </div>

        <div className="legal-block" id="pc8">
          <h2>8. Géolocalisation</h2>
          <p>L'utilisation de la géolocalisation dans Clockeo est soumise aux règles suivantes :</p>
          <ul>
            <li>La collecte des coordonnées GPS nécessite votre <strong>autorisation explicite</strong> via le navigateur</li>
            <li>La géolocalisation n'est activée <strong>qu'au moment du pointage</strong> — Clockeo ne traque pas votre position en continu</li>
            <li>Les coordonnées GPS collectées sont uniquement utilisées pour valider la présence sur un site</li>
            <li>Vous pouvez révoquer l'autorisation dans les paramètres de votre navigateur</li>
          </ul>
          <p>L'employeur (administrateur) est informé que la mise en place d'un dispositif de géolocalisation des salariés est soumise à des obligations légales spécifiques.</p>
        </div>

        <div className="legal-block" id="pc9">
          <h2>9. Vos droits (RGPD)</h2>
          <p>Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :</p>
          <div className="legal-rights-grid">
            {[
              { t: 'Droit d\'accès', d: 'Obtenir une copie de vos données personnelles détenues par Clockeo.' },
              { t: 'Droit de rectification', d: 'Corriger des données inexactes ou incomplètes vous concernant.' },
              { t: 'Droit à l\'effacement', d: 'Demander la suppression de vos données, sous réserve des obligations légales.' },
              { t: 'Droit à la portabilité', d: 'Recevoir vos données dans un format structuré et lisible par machine.' },
              { t: 'Droit d\'opposition', d: 'Vous opposer à un traitement fondé sur l\'intérêt légitime.' },
              { t: 'Droit à la limitation', d: 'Demander la suspension temporaire du traitement de vos données.' },
            ].map(r => (
              <div key={r.t} className="legal-right-item">
                <div className="legal-right-title">{r.t}</div>
                <div className="legal-right-desc">{r.d}</div>
              </div>
            ))}
          </div>
          <p style={{ marginTop: 20 }}>Pour exercer vos droits, contactez-nous à <a href="mailto:contact@clockeo.fr">contact@clockeo.fr</a>. Nous nous engageons à répondre dans un délai d'un mois.</p>
          <p>Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la <strong>CNIL</strong> : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a></p>
        </div>

        <div className="legal-block" id="pc10">
          <h2>10. Contact</h2>
          <p>Pour toute question relative à cette politique de confidentialité ou pour exercer vos droits :</p>
          <div className="legal-highlight">
            <p>
              <strong>Email :</strong> <a href="mailto:contact@clockeo.fr">contact@clockeo.fr</a><br />
              <strong>Objet :</strong> [RGPD] suivi de votre demande<br />
              <strong>Délai de réponse :</strong> 30 jours maximum
            </p>
          </div>
        </div>
      </div>
    </LegalLayout>
  );
}
